import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import banner from "../../../assets/Serviceasset/sevicebanner.png";
import prop1 from "../../../assets/Serviceasset/sevicebanner.png";
import { toast } from "react-toastify";
import axios from "axios";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../shadcn/components/ui/AlertDialog";

export default function MyPropertiesServices({
  properties: initialProperties,
}) {
  // State to handle the search input
  const [searchQuery, setSearchQuery] = useState("");
  const [properties, setProperties] = useState(initialProperties || []);
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [sortDirection, setSortDirection] = useState("asc");
  const [allProperties, setAllProperties] = useState([]);
  const [filteredAllProperties, setFilteredAllProperties] = useState([]);
  const [allGeneralServices, setAllGeneralServices] = useState([]);
  const [allTransportServices, setAllTransportServices] = useState([]);
  const [filteredAllServices, setFilteredAllServices] = useState([]);
  // State for Property Deletion
  const [isPropertyDeleteDialogOpen, setIsPropertyDeleteDialogOpen] =
    useState(false);
  // State for Service Deletion
  const [isServiceDeleteDialogOpen, setIsServiceDeleteDialogOpen] =
    useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("authToken");

      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        setIsLoading(false);
        return;
      }

      try {
        const [propertiesResponse, servicesResponse, transportResponse] =
          await Promise.all([
            axios.post(
              "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/get",
              { token },
              { headers: { "Content-Type": "application/json" } }
            ),
            axios.post(
              "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/service-form/get",
              { token },
              { headers: { "Content-Type": "application/json" } }
            ),
            axios.post(
              "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/get",
              { token },
              { headers: { "Content-Type": "application/json" } }
            ),
          ]);

        // Map property data to frontend structure
        const propertyData = propertiesResponse.data?.form_data || [];
        const mappedProperties = propertyData.map((item) => {
          return {
            id: item._id,
            name: item.propertyDetails?.title || "N/A",
            porpertyAddress: item.propertyDetails?.address || "N/A",
            price: item.propertyDetails?.price || "N/A",
            image: item.uploadFiles[0] || "/placeholder-image.jpg",
            details: item.propertyDetails || {},
            propertyDetails: item.propertyDetails || {},
            location: item.location || {},
            neighborhood: item.neighborhood || {},
            uploadFiles: item.uploadFiles || [],
            address: item.location?.address || "N/A",
          };
        });

        setProperties(mappedProperties.filter(Boolean));
        setFilteredProperties(mappedProperties.filter(Boolean));

        // Extract service details from both responses
        const servicesData = servicesResponse.data?.form_data || [];
        const transportData = transportResponse.data?.form_data || [];

        // Flatten and merge serviceDetails from both datasets
        const combinedServices = [
          ...servicesData.map((item) => ({
            id: item._id,
            type: "Service Form",
            details: item.serviceDetails,
          })),
          ...transportData.map((item) => ({
            id: item._id,
            type: "Transport Form",
            details: item.vehicleDetails,
          })),
        ];

        setServices(combinedServices.filter(Boolean));
        setFilteredServices(combinedServices.filter(Boolean));
      } catch (error) {
        console.error("Error fetching data:", error.response?.data);
        toast.error(
          error.response?.data?.message ||
            "An unexpected error occurred while fetching data."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Delete property
  const handleDeletePropertyClick = (property) => {
    console.log("Clicked to delete:", property);

    setPropertyToDelete(property);
    setIsPropertyDeleteDialogOpen(true);
  };

  const handleDeletePropertyConfirm = async () => {
    console.log("Confirming delete for:", propertyToDelete);

    if (!propertyToDelete) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.error("Authentication token is missing. Please log in again.");
      return;
    }

    try {
      console.log("Deleting Property:", propertyToDelete);

      const deleteUrl =
        "https://silver-tlc-backend-delta.vercel.app/api/v1/superadmin/postservice-form/delete";

      const response = await axios.delete(deleteUrl, {
        headers: { "Content-Type": "application/json" },
        data: { form_id: propertyToDelete.id, token },
      });

      console.log("Delete API Response:", response.data); // Debugging

      setProperties((prevProperties) =>
        prevProperties.filter((s) => s.id !== propertyToDelete.id)
      );
      setFilteredProperties((prevFilteredProperties) =>
        prevFilteredProperties.filter((s) => s.id !== propertyToDelete.id)
      );
      setFilteredAllProperties((prevFilteredProperties) =>
        prevFilteredProperties.filter((s) => s.id !== propertyToDelete.id)
      );

      toast.success("Property deleted successfully!");
    } catch (error) {
      console.error("Error deleting property:", error.response);
      toast.error(
        error.response?.data?.message || "Failed to delete the property."
      );
    } finally {
      setIsDeleteDialogOpen(false);
      setPropertyToDelete(null);
    }
  };

  // Delete service
  const handleDeleteServiceClick = (service, formType) => {
    setServiceToDelete({ ...service, formType });
    setIsServiceDeleteDialogOpen(true);
  };

  const handleDeleteServiceConfirm = async () => {
    if (!serviceToDelete) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.error("Authentication token is missing. Please log in again.");
      return;
    }

    try {
      const deleteUrl =
        serviceToDelete.formType === "Service Form"
          ? "https://silver-tlc-backend-delta.vercel.app/api/v1/superadmin/service-form/delete"
          : "https://silver-tlc-backend-delta.vercel.app/api/v1/superadmin/transport-form/delete";

      await axios.delete(deleteUrl, {
        headers: { "Content-Type": "application/json" },
        data: { form_id: serviceToDelete.id, token },
      });

      setServices((prevServices) =>
        prevServices.filter((s) => s.id !== serviceToDelete.id)
      );
      setFilteredServices((prevFilteredServices) =>
        prevFilteredServices.filter((s) => s.id !== serviceToDelete.id)
      );

      toast.success(`${serviceToDelete.formType} deleted successfully!`);
    } catch (error) {
      console.error(
        `Error deleting ${serviceToDelete.formType}:`,
        error.response
      );
      toast.error(
        error.response?.data?.message ||
          `Failed to delete the ${serviceToDelete.formType}.`
      );
    } finally {
      setIsDeleteDialogOpen(false);
      setServiceToDelete(null);
    }
  };

  // Edit property
  const handleEditPropertyClick = (formType, property) => {
    if (!property) return;

    const formId = property.id;
    const formData = {
      propertyDetails: property.propertyDetails || {},
      location: property.location || {},
      neighborhood: property.neighborhood || {},
      uploadFiles: property.uploadFiles || [],
    };

    navigate("/superadmin/Property", {
      state: { formData, formType, formId },
    });
  };

  // Edit service
  const handleEditServiceClick = (formType, service) => {
    console.log("Edit Service Clicked:", formType, service); // Debugging
    const formId = service.id;
    const formData = service.details;

    if (formType === "Service Form") {
      navigate("/superadmin/Service%20Information", {
        state: { formData, formType, formId },
      });
      console.log("Navigating to Service Information"); // Debugging
    } else if (formType === "Transport Form") {
      navigate("/superadmin/Transportation", {
        state: { formData, formType, formId },
      });
      console.log("Navigating to Transportation"); // Debugging
    }
  };

  // Function to handle edit click
  const handleEditClick = (formType, property) => {
    handleEditPropertyClick(formType, property);
  };
  const handleEditClick2 = (formType, service) => {
    handleEditServiceClick(formType, service);
  };

  // Search feature
  const handleSearch = () => {
    if (searchTerm.trim() === "") {
      setFilteredProperties(properties);
    } else {
      const sortedProperties = [...properties].sort((a, b) => {
        const isAMatch = a.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        const isBMatch = b.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

        if (isAMatch && !isBMatch) return -1;
        if (!isAMatch && isBMatch) return 1;
        return 0;
      });

      setFilteredProperties(sortedProperties);
    }
  };

  // Filter feature
  const handleFilterClick = () => {
    setIsFilterOpen((prev) => !prev);
  };

  const handleSortByPrice = () => {
    const sorted = [...filteredProperties].sort((a, b) => {
      if (sortDirection === "asc") {
        return a.price - b.price;
      } else {
        return b.price - a.price;
      }
    });

    setFilteredProperties(sorted);
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  // Function to format service type
  const formatServiceType = (service) => {
    if (service.details.address1 && service.details.email) {
      return "Service Form";
    }
    if (service.details.pickUpLocation && service.details.dropOffLocation) {
      return "Transport Form";
    }
    return "Unknown";
  };

  // ================================= Fetching all Properties and Services ======================================
  useEffect(() => {
    const fetchAllProperties = async () => {
      setIsLoading(true);

      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          setIsLoading(false);
          return;
        }

        const response = await axios.get(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/get-alluser"
        );

        const allPropertiesData = response.data?.postServiceFormData || [];
        // console.log("All Properties Data:", allPropertiesData);

        const mappedAllProperties = allPropertiesData.map((item) => {
          return {
            id: item._id,
            name: item.propertyDetails?.title || "N/A",
            address: item.propertyDetails?.address || "N/A",
            price: item.propertyDetails?.price || "N/A",
            provider: item.propertyDetails?.email || "N/A",
            image: item.uploadFiles[0] || "/placeholder-image.jpg",
            details: item.propertyDetails || {},
          };
        });

        setAllProperties(mappedAllProperties);
        setFilteredAllProperties(mappedAllProperties);
      } catch (error) {
        console.error("Error fetching all properties:", error.response?.data);
        toast.error(
          error.response?.data?.message ||
            "An unexpected error occurred while fetching all properties."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllProperties();
  }, []);

  // ------------ All Services----------------
  useEffect(() => {
    const fetchAllServices = async () => {
      setIsLoading(true);

      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          setIsLoading(false);
          return;
        }

        const [generalServicesResponse, transportServicesResponse] =
          await Promise.all([
            axios.get(
              "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/service-form/get-alluser"
            ),
            axios.get(
              "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/get-alluser"
            ),
          ]);

        const generalServicesData =
          generalServicesResponse.data?.serviceFormData || [];
        const transportServicesData =
          transportServicesResponse.data?.transportFormData || [];

        // Map General Services
        const mappedGeneralServices = generalServicesData.map((item) => ({
          id: item._id,
          type: "Service Form",
          details: item.serviceDetails,
        }));

        // Map Transport Services
        const mappedTransportServices = transportServicesData.map((item) => ({
          id: item._id,
          type: "Transport Form",
          details: item.vehicleDetails,
        }));

        // Combine all services
        const combinedAllServices = [
          ...mappedGeneralServices,
          ...mappedTransportServices,
        ];

        setAllGeneralServices(mappedGeneralServices);
        setAllTransportServices(mappedTransportServices);
        setFilteredAllServices(combinedAllServices);
      } catch (error) {
        console.error("Error fetching all services:", error.response?.data);
        toast.error(
          error.response?.data?.message ||
            "An unexpected error occurred while fetching all services."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllServices();
  }, []);

  return (
    <div className="md:p-8 w-full">
      {/* Delete Dialog for properties */}
      <AlertDialog
        open={isPropertyDeleteDialogOpen}
        onOpenChange={setIsPropertyDeleteDialogOpen}
      >
        <AlertDialogContent className="bg-white">
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete your
              property and remove all associated data.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="bg-gray-100 hover:bg-gray-200"
              onClick={() => setPropertyToDelete(null)}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-red-600 hover:bg-red-700 text-white"
              onClick={() => {
                console.log("Delete button clicked"); // Debugging
                handleDeletePropertyConfirm();
              }}
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Delete Dialog for Services */}
      <AlertDialog
        open={isServiceDeleteDialogOpen}
        onOpenChange={setIsServiceDeleteDialogOpen}
      >
        <AlertDialogContent className="bg-white">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Confirmation</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to delete this service? This action cannot
              be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="bg-gray-100 hover:bg-gray-200"
              onClick={() => setServiceToDelete(null)}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-red-600 hover:bg-red-700 text-white"
              onClick={handleDeleteServiceConfirm}
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Properties Table */}
      <div className="bg-white rounded-lg lg:p-6 overflow-x-auto w-[73vw] md:w-full">
        <div
          className="relative bg-cover bg-center h-64 lg:w-full lg:h-96 w-[73vw] rounded-lg overflow-hidden shadow-md"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="text-center text-white lg:px-8 overflow-x-auto">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">
                My Properties / Services
              </h1>
              <div className="mt-4 flex flex-col sm:flex-row justify-center gap-2 sm:gap-0 relative">
                {/* Search Input */}
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search for Properties"
                  className="w-[65vw] sm:w-[40rem] p-2 rounded-lg border-none text-lg focus:ring-0 text-black pl-5"
                />
                {/* Search Button */}
                <button
                  onClick={handleSearch}
                  className="w-full sm:w-auto px-6 py-2 bg-purple-600 text-white rounded-r-lg flex justify-center items-center hover:bg-purple-700 transition-all"
                >
                  Search
                </button>
                {/* Filter Button */}
                <button
                  onClick={handleFilterClick}
                  className="w-full sm:w-auto sm:ml-4 mt-2 sm:mt-0 px-6 py-2 bg-purple-600 text-white rounded-lg flex justify-center items-center hover:bg-purple-700 transition-all"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2"
                  >
                    <path d="M0 3.375H18V1.125H0V3.375Z" fill="white" />
                    <path
                      d="M2.25 7.875H15.75V5.625H2.25V7.875Z"
                      fill="white"
                    />
                    <path
                      d="M4.5 12.375H13.5V10.125H4.5V12.375Z"
                      fill="white"
                    />
                    <path
                      d="M11.25 16.875H6.75V14.625H11.25V16.875Z"
                      fill="white"
                    />
                  </svg>
                  Filter
                </button>
                {/* Dropdown Menu */}
                {isFilterOpen && (
                  <div className="absolute top-full right-[-1rem] mt-2 bg-white text-black shadow-lg rounded-lg z-10 w-32">
                    <button
                      onClick={handleSortByPrice}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 transition-all text-black hover:rounded-lg"
                    >
                      Sort by Price (
                      {sortDirection === "asc" ? "Ascending" : "Descending"})
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* My properties  */}
        <div>
          <h2 className="text-2xl flex font-bold mb-4 mt-5 items-center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-2"
            >
              <path
                d="M22.9564 22.4348H20.6086V1.5652H21.3912C21.8234 1.5652 22.1738 1.21481 22.1738 0.782578C22.1738 0.350344 21.8234 0 21.3912 0C19.8626 0 3.31816 0 2.60857 0C2.17638 0 1.82595 0.350391 1.82595 0.782625C1.82595 1.21486 2.17634 1.56525 2.60857 1.56525H3.3912V22.4348H1.04337C0.61118 22.4348 0.260742 22.7852 0.260742 23.2174C0.260742 23.6497 0.611133 24 1.04337 24C1.51835 24 20.9871 24 22.9564 24C23.3886 24 23.739 23.6496 23.739 23.2174C23.739 22.7851 23.3886 22.4348 22.9564 22.4348ZM19.0434 22.4348H4.9564V1.5652H19.0434V22.4348Z"
                fill="black"
              />
            </svg>
            My Properties
            <svg
              width="5"
              height="5"
              viewBox="0 0 5 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-2"
            >
              <circle cx="2.19095" cy="2.3815" r="2.19095" fill="#949494" />
            </svg>
          </h2>
          {/* Search Bar */}
          {/* <div className="mb-4">
          <input
            type="text"
            placeholder="Search properties..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div> */}
          <table className="table-auto border-b text-left border-collapse overflow-x-auto w-[80vw] lg:w-full">
            <thead>
              <tr className="border-b">
                <th className="p-4">Thumbnail Image</th>
                <th className="p-4">Property Name</th>
                <th className="p-4">Address</th>
                <th className="p-4">Price</th>
                <th className="p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProperties.map((property) => (
                <tr key={property.id} className="border-b">
                  <td className="p-4">
                    <img
                      src={property.image}
                      alt="Thumbnail"
                      className="h-32 w-48 object-cover rounded"
                    />
                  </td>
                  <td className="p-4">{property.name}</td>
                  <td className="p-4">{property.address}</td>
                  <td className="p-4">{property.price}</td>
                  <td className="p-4 space-x-4 flex justify-start items-center mt-[3rem]">
                    <button
                      className=" flex items-center justify-center gap-2 text-sm"
                      onClick={(e) => {
                        console.log("Property object:", property);
                        e.preventDefault();
                        handleEditClick("Property", property);
                      }}
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.13388 14.8751L14.1339 4.87509L10.125 0.866211L0.125 10.8663V14.8751H4.13388ZM10.125 2.63398L12.3662 4.87509L10.75 6.49125L8.5089 4.25011L10.125 2.63398ZM7.62498 5.13399L9.86615 7.37509L3.61612 13.6251H1.375V11.384L7.62498 5.13399Z"
                          fill="#171A1F"
                        />
                      </svg>
                      Edit
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        console.log("Deleting Property:", property);
                        handleDeletePropertyClick(property);
                      }}
                      className=" flex items-center justify-center gap-2 text-sm"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5599 5.3L11.5599 12.14C11.5599 12.7696 11.0495 13.28 10.4199 13.28L3.57994 13.28C2.95034 13.28 2.43994 12.7696 2.43994 12.14L2.43994 5.3"
                          stroke="#565D6D"
                          strokeWidth="1.368"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                        />
                        <path
                          d="M0.72998 3L13.27 3"
                          stroke="#565D6D"
                          strokeWidth="1.368"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                        <path
                          d="M4.71997 3L4.71997 0.720001L9.27997 0.720001V3"
                          stroke="#565D6D"
                          strokeWidth="1.368"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                        <path
                          d="M8.71004 7L5.29004 10.42"
                          stroke="#565D6D"
                          strokeWidth="1.368"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                        <path
                          d="M8.71004 10.42L5.29004 7"
                          stroke="#565D6D"
                          strokeWidth="1.368"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                      </svg>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filteredProperties.length === 0 && (
            <p className="text-center text-gray-500 mt-4">
              No properties match your search.
            </p>
          )}
        </div>
      </div>

      {/* Services Table */}
      <div className="mt-12 bg-white w-[70vw] overflow-x-auto lg:w-[75vw] rounded-lg p-6">
        <h2 className="text-2xl flex font-bold mb-4 items-center">
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          ></svg>
          My Services
        </h2>
        <div className="w-[50vw]">
          {isLoading ? (
            <p>Loading services...</p>
          ) : (
            <table className="table-auto w-[70vw] text-left border-collapse">
              <thead>
                <tr className="border-b">
                  {[
                    "Service Name",
                    "Service Type",
                    "Provider",
                    "Price",
                    "Actions",
                  ].map((header, idx) => (
                    <th key={idx} className="p-4">
                      <div className="flex items-center justify-between">
                        <span>{header}</span>
                        <svg
                          width="5"
                          height="20"
                          viewBox="0 0 5 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-2"
                        >
                          {/* SVG Paths */}
                        </svg>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredServices.map((service, index) => (
                  <tr key={service.id || index} className="border-b">
                    <td className="p-4 text-sm">
                      {service.details.address1 || service.details.companions}
                    </td>
                    <td className="p-4 text-sm">{service.type}</td>
                    <td className="p-4 text-sm">{service.details.email}</td>
                    <td className="p-4 text-sm">${service.details.phone}</td>
                    <td className="p-4">
                      <div className="flex flex-wrap gap-5">
                        <button
                          onClick={() => {
                            console.log("Service object:", service); // Debugging
                            handleEditClick2(
                              formatServiceType(service),
                              service
                            );
                          }}
                          className="flex items-center space-x-2 gap-1 text-sm"
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.13388 14.8751L14.1339 4.87509L10.125 0.866211L0.125 10.8663V14.8751H4.13388ZM10.125 2.63398L12.3662 4.87509L10.75 6.49125L8.5089 4.25011L10.125 2.63398ZM7.62498 5.13399L9.86615 7.37509L3.61612 13.6251H1.375V11.384L7.62498 5.13399Z"
                              fill="#171A1F"
                            />
                          </svg>
                          Edit
                        </button>
                        <button
                          className="flex items-center space-x-2 gap-1 text-sm"
                          onClick={() =>
                            handleDeleteServiceClick(service, service.type)
                          }
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.5599 5.3L11.5599 12.14C11.5599 12.7696 11.0495 13.28 10.4199 13.28L3.57994 13.28C2.95034 13.28 2.43994 12.7696 2.43994 12.14L2.43994 5.3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                            />
                            <path
                              d="M0.72998 3L13.27 3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M4.71997 3L4.71997 0.720001L9.27997 0.720001V3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M8.71004 7L5.29004 10.42"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M8.71004 10.42L5.29004 7"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                          </svg>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* All Properties */}
      <div>
        <h2 className="text-2xl flex font-bold mb-4 mt-5 items-center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mr-2"
          >
            <path
              d="M22.9564 22.4348H20.6086V1.5652H21.3912C21.8234 1.5652 22.1738 1.21481 22.1738 0.782578C22.1738 0.350344 21.8234 0 21.3912 0C19.8626 0 3.31816 0 2.60857 0C2.17638 0 1.82595 0.350391 1.82595 0.782625C1.82595 1.21486 2.17634 1.56525 2.60857 1.56525H3.3912V22.4348H1.04337C0.61118 22.4348 0.260742 22.7852 0.260742 23.2174C0.260742 23.6497 0.611133 24 1.04337 24C1.51835 24 20.9871 24 22.9564 24C23.3886 24 23.739 23.6496 23.739 23.2174C23.739 22.7851 23.3886 22.4348 22.9564 22.4348ZM19.0434 22.4348H4.9564V1.5652H19.0434V22.4348Z"
              fill="black"
            />
          </svg>
          All Properties
          <svg
            width="5"
            height="5"
            viewBox="0 0 5 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ml-2"
          >
            <circle cx="2.19095" cy="2.3815" r="2.19095" fill="#949494" />
          </svg>
        </h2>

        <table className="table-auto border-b text-left border-collapse overflow-x-auto w-[80vw] lg:w-full">
          <thead>
            <tr className="border-b">
              <th className="p-4">Thumbnail Image</th>
              <th className="p-4">Property Name</th>
              <th className="p-4">Address</th>
              <th className="p-4">Price</th>
              <th className="p-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAllProperties.map((property) => (
              <tr key={property.id} className="border-b">
                <td className="p-4">
                  <img
                    src={property.image}
                    alt="Thumbnail"
                    className="h-32 w-48 object-cover rounded"
                  />
                </td>
                <td className="p-4">{property.name}</td>
                <td className="p-4">{property.address}</td>
                <td className="p-4">{property.price}</td>
                <td className="p-4 space-x-4 flex justify-start items-center mt-[3rem]">
                  <button
                    className=" flex items-center justify-center gap-2 text-sm"
                    onClick={(e) => {
                      console.log("Property object:", property);
                      e.preventDefault();
                      handleEditClick("Property", property);
                    }}
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.13388 14.8751L14.1339 4.87509L10.125 0.866211L0.125 10.8663V14.8751H4.13388ZM10.125 2.63398L12.3662 4.87509L10.75 6.49125L8.5089 4.25011L10.125 2.63398ZM7.62498 5.13399L9.86615 7.37509L3.61612 13.6251H1.375V11.384L7.62498 5.13399Z"
                        fill="#171A1F"
                      />
                    </svg>
                    Edit
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      console.log("Deleting Property:", property);
                      handleDeletePropertyClick(property, property.type);
                    }}
                    className=" flex items-center justify-center gap-2 text-sm"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5599 5.3L11.5599 12.14C11.5599 12.7696 11.0495 13.28 10.4199 13.28L3.57994 13.28C2.95034 13.28 2.43994 12.7696 2.43994 12.14L2.43994 5.3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                      <path
                        d="M0.72998 3L13.27 3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M4.71997 3L4.71997 0.720001L9.27997 0.720001V3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M8.71004 7L5.29004 10.42"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M8.71004 10.42L5.29004 7"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                    </svg>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredAllProperties.length === 0 && (
          <p className="text-center text-gray-500 mt-4">
            No properties match your search.
          </p>
        )}
      </div>

      {/* All Services */}
      <div className="mt-12 bg-white w-[70vw] overflow-x-auto lg:w-[75vw] rounded-lg p-6">
        <h2 className="text-2xl flex font-bold mb-4 items-center">
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          ></svg>
          All Services
        </h2>
        <div className="w-[50vw]">
          {isLoading ? (
            <p>Loading services...</p>
          ) : (
            <table className="table-auto w-[70vw] text-left border-collapse">
              <thead>
                <tr className="border-b">
                  {[
                    "Service Name",
                    "Service Type",
                    "Provider",
                    "Price",
                    "Actions",
                  ].map((header, idx) => (
                    <th key={idx} className="p-4">
                      <div className="flex items-center justify-between">
                        <span>{header}</span>
                        <svg
                          width="5"
                          height="20"
                          viewBox="0 0 5 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-2"
                        >
                          {/* SVG Paths */}
                        </svg>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredAllServices.map((service, index) => (
                  <tr key={service.id || index} className="border-b">
                    <td className="p-4 text-sm">
                      {service.details.address1 || service.details.companions}
                    </td>
                    <td className="p-4 text-sm">{service.type}</td>
                    <td className="p-4 text-sm">{service.details.email}</td>
                    <td className="p-4 text-sm">${service.details.phone}</td>
                    <td className="p-4">
                      <div className="flex flex-wrap gap-5">
                        <button
                          onClick={() => {
                            console.log("Service object:", service); // Debugging
                            handleEditClick2(
                              formatServiceType(service),
                              service
                            );
                          }}
                          className="flex items-center space-x-2 gap-1 text-sm"
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.13388 14.8751L14.1339 4.87509L10.125 0.866211L0.125 10.8663V14.8751H4.13388ZM10.125 2.63398L12.3662 4.87509L10.75 6.49125L8.5089 4.25011L10.125 2.63398ZM7.62498 5.13399L9.86615 7.37509L3.61612 13.6251H1.375V11.384L7.62498 5.13399Z"
                              fill="#171A1F"
                            />
                          </svg>
                          Edit
                        </button>
                        <button
                          className="flex items-center space-x-2 gap-1 text-sm"
                          onClick={() =>
                            handleDeleteServiceClick(service, service.type)
                          }
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.5599 5.3L11.5599 12.14C11.5599 12.7696 11.0495 13.28 10.4199 13.28L3.57994 13.28C2.95034 13.28 2.43994 12.7696 2.43994 12.14L2.43994 5.3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                            />
                            <path
                              d="M0.72998 3L13.27 3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M4.71997 3L4.71997 0.720001L9.27997 0.720001V3"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M8.71004 7L5.29004 10.42"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                            <path
                              d="M8.71004 10.42L5.29004 7"
                              stroke="#565D6D"
                              strokeWidth="1.368"
                              strokeMiterlimit="10"
                              strokeLinecap="square"
                            />
                          </svg>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
